var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmptyDialWithLines = function SvgEmptyDialWithLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "236px",
    viewBox: "0 0 236 236",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "EmptyDialWithLines")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmptyDialWithLines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 8,
    x2: 118,
    y2: 28,
    id: "Line",
    stroke: "#E6E6E6",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 118,
    x2: 208,
    y2: 118,
    id: "Line-2",
    stroke: "#E6E6E6",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 228,
    x2: 118,
    y2: 208,
    id: "Line-3",
    stroke: "#E6E6E6",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 118,
    x2: 28,
    y2: 118,
    id: "Line-4",
    stroke: "#E6E6E6",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#E6E6E6",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 118,
    r: 115
  }))))));
};

export { SvgEmptyDialWithLines as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyDialWithLines.dc2fb0e6.svg";